var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"player-halite-chart"},[_c('svg',{ref:"mainSvg",attrs:{"width":"100%","height":"130"}})])}
var staticRenderFns = []

export { render, staticRenderFns }